import { MAX_AREA_SERVICED_KM, MIN_AREA_SERVICED_KM } from "./constants";

export const clampAreaServiced = (radiusKm: number): number =>
  Math.min(
    MAX_AREA_SERVICED_KM,
    Math.max(MIN_AREA_SERVICED_KM, Math.round(radiusKm)),
  );
